import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getUserPageAuth } from '../../../utils/page-auth';
import { Helmet } from 'react-helmet';
import NeedSettlement from './needSettlement';
import Settlemented from './settlemented';

function WalletSettlementMain() {
  // -- component const --//
  // 페이지 제목
  const title = '장부 정산';

  // -- useSelector & dispatch --//
  const user = useSelector((state) => state.authReducer.user);

  // -- state --//
  const [readOnly, setReadOnly] = useState(true);
  const [className, setClassName] = useState('tab1');

  // -- react hooks --//
  useEffect(() => {
    getUserPageAuth(user).then((res) => setReadOnly(res));
  }, [user]);

  // -- render --//
  return (
    <div className="page">
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <div className="topSection flowRoot">
        <div className="leftSection">
          <p className="titleText">
            {title}
            {readOnly ? '(읽기전용)' : ''}
          </p>
        </div>

        <div className="rightSection">
          <button
            className={className === 'tab1' ? 'tab1 active' : 'tab1'}
            onClick={() => setClassName('tab1')}
          >
            정산 필요
          </button>
          <button
            className={className === 'tab2' ? 'tab2 active' : 'tab2'}
            onClick={() => setClassName('tab2')}
          >
            정산 완료
          </button>
        </div>
      </div>

      <div className="spaceDiv10"/>

      <div className="divTaps">
        {className === 'tab1' && <NeedSettlement />}
        {className === 'tab2' && <Settlemented />}
      </div>

    </div>
  )
}

export default WalletSettlementMain;
